function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA -IDP Cookies compliance
 * 
 */
import * as React from 'react';
import { TERMS_URL } from '../../data/Data';
import { acceptCookies } from '../../actions';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './Cookies.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export class Cookies extends React.Component {
  constructor(props) {
    super(props);
    /**
     * handleKeydown
     */
    _defineProperty(this, "handleKeydown", e => {
      // $FlowFixMe
      const {
        key
      } = e;
      const {
        focus
      } = this.state;
      if (focus && key === 'Enter') {
        e.preventDefault();
        this.done();
      }
    });
    /**
     * focus
     */
    _defineProperty(this, "focus", () => {
      let {
        focus
      } = this.state;
      this.setState({
        focus: !focus
      });
    });
    /**
     * Done
     */
    _defineProperty(this, "done", () => {
      this.props.acceptCookies(true);
    });
    this.state = {
      focus: false
    };
  }
  componentDidMount() {
    // $FlowFixMe
    document.addEventListener('keydown', this.handleKeydown);
  }
  componentWillUnmount() {
    // $FlowFixMe
    document.removeEventListener('keydown', this.handleKeydown);
  }
  render() {
    const {
      cookies
    } = this.props;
    if (cookies === true) {
      return null;
    }
    return /*#__PURE__*/_jsx("div", {
      className: "AAA-cookies",
      children: /*#__PURE__*/_jsxs("div", {
        className: "inner",
        children: [/*#__PURE__*/_jsxs("p", {
          children: ["We use cookies on this site. The cookies used may retain personal information or personal identifying information without an IDP application being submitted. Please read", ' ', /*#__PURE__*/_jsx("a", {
            href: TERMS_URL,
            target: "_blank",
            rel: "noopener noreferrer",
            children: "Privacy Policy and Terms and Conditions"
          }), ' ', "documents."]
        }), /*#__PURE__*/_jsx("div", {
          className: "icon",
          onClick: this.done,
          tabIndex: "0",
          role: "button",
          onFocus: this.focus,
          onBlur: this.focus,
          children: /*#__PURE__*/_jsx(FontAwesomeIcon, {
            icon: "xmark"
          })
        })]
      })
    });
  }
}
_defineProperty(Cookies, "defaultProps", {
  cookies: false
});
const mapStateToProps = ({
  cookies
}) => {
  return {
    cookies
  };
};
const mapDispatchToProps = dispatch => {
  return {
    acceptCookies: value => {
      dispatch(acceptCookies(value));
    }
  };
};
const VisibleCookies = connect(mapStateToProps, mapDispatchToProps)(Cookies);
export default VisibleCookies;